import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="fixed top-0 left-0 right-0 bg-white bg-opacity-95 shadow-sm z-50" data-id="element-142">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="flex justify-between items-center h-20" data-id="element-144">
          {/* Logo */}
          <div className="flex items-center" data-id="element-145">
            <Link to="/" className="text-navy-700 text-2xl font-bold" data-id="element-146">
              <Logo data-id="element-147" />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-148">
            <Link to="/about-us" className="text-gray-600 hover:text-[#0a2351] transition-colors duration-300 font-medium" data-id="element-149">
              About Us
            </Link>
            <Link to="/investments" className="text-gray-600 hover:text-[#0a2351] transition-colors duration-300 font-medium" data-id="element-150">
              Investments
            </Link>
            <Link to="/portfolio" className="text-gray-600 hover:text-[#0a2351] transition-colors duration-300 font-medium" data-id="element-151">
              Portfolio
            </Link>
            <Link to="/testimonials" className="text-gray-600 hover:text-[#0a2351] transition-colors duration-300 font-medium" data-id="element-152">
              Testimonials
            </Link>
            <Link to="/contact" className="text-gray-600 hover:text-[#0a2351] transition-colors duration-300 font-medium" data-id="element-153">
              Contact
            </Link>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-154">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-600 hover:text-gray-900 focus:outline-none" data-id="element-155">
              {isMenuOpen ? <X size={24} data-id="element-156" /> : <Menu size={24} data-id="element-157" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white px-2 pt-2 pb-4 shadow-lg" data-id="element-158">
          <div className="flex flex-col space-y-3" data-id="element-159">
            <Link to="/about-us" className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-[#0a2351] rounded-md" onClick={() => setIsMenuOpen(false)} data-id="element-160">
              About Us
            </Link>
            <Link to="/investments" className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-[#0a2351] rounded-md" onClick={() => setIsMenuOpen(false)} data-id="element-161">
              Investments
            </Link>
            <Link to="/portfolio" className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-[#0a2351] rounded-md" onClick={() => setIsMenuOpen(false)} data-id="element-162">
              Portfolio
            </Link>
            <Link to="/testimonials" className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-[#0a2351] rounded-md" onClick={() => setIsMenuOpen(false)} data-id="element-163">
              Testimonials
            </Link>
            <Link to="/contact" className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-[#0a2351] rounded-md" onClick={() => setIsMenuOpen(false)} data-id="element-164">
              Contact
            </Link>
          </div>
        </div>}
    </header>;
};
const NavLink = ({
  href,
  children
}) => {
  return <a href={href} className="text-gray-600 hover:text-[#0a2351] transition-colors duration-300 font-medium" data-id="element-165">
      {children}
    </a>;
};
const MobileNavLink = ({
  href,
  children,
  onClick
}) => {
  return <a href={href} className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-[#0a2351] rounded-md" onClick={onClick} data-id="element-166">
      {children}
    </a>;
};